import { useField } from "formik";
import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { useIntl } from "react-intl";
import StarRatings from "react-star-ratings";

export interface ISimpleRating {
    name: string;
    label?: string;
    disable?: boolean;
    starRatedColor?: string;
    starHoverColor?: string;
    starDimension?: string;
    numberOfStars?: number;
}
interface StarRatingProps {
    rating?: number;
    numberOfStars?: number;
    changeRating?: (rating: number) => void;
    starRatedColor?: string;
    starEmptyColor?: string;
    starHoverColor?: string;
    starDimension?: string;
    starSpacing?: string;
    gradientPathName?: string;
    ignoreInlineStyles?: boolean;
    svgIconPath?: string;
    svgIconViewBox?: string;
    name?: string;
}
const SimpleRating = (props: ISimpleRating) => {
    const {
        name,
        label,
        disable = false,
        starRatedColor,
        starHoverColor,
        starDimension = "16px",
        numberOfStars = 5,
    } = props;
    const [, rateMetaProps, rateHelperProps] = useField(name);
    const [LoadingColor, setLoadingColor] = useState("");
    const { formatMessage } = useIntl();

    useEffect(() => {
        setLoadingColor(getComputedStyle(document.body).getPropertyValue("--kt-primary"));
    }, []);
    const currentProps: StarRatingProps = {
        rating: rateMetaProps.value || undefined,
        starRatedColor: starRatedColor || LoadingColor,
        starHoverColor,
        starDimension,
        changeRating: (rating: number) => {
            rateHelperProps.setValue(rating);
            rateHelperProps.setTouched(true);
        },
        numberOfStars,
        name,
    };
    if (disable) delete currentProps.changeRating;
    return (
        <div className="d-flex flex-column mb-2">
            {label && <Form.Label>{label}</Form.Label>}
            <StarRatings {...currentProps} />
            {rateMetaProps.touched && rateMetaProps.error && (
                <div className="fv-plugins-message-container">
                    <div className="fv-help-block">
                        <span role="alert">
                            {" "}
                            {rateMetaProps.error.includes("error.")
                                ? formatMessage({ id: rateMetaProps.error })
                                : rateMetaProps.error}
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SimpleRating;
